import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { isEmpty, set } from 'lodash';
import LossCode from 'models/claims/lossCode/Model.LossCode';
import LineItem from 'models/enums/LineItem';

type Props = {
  data: Partial<Model.IClaimTypeJobItemTemplate>;
  lossCodes: LossCode[];
  onSave(data: Model.IClaimTypeJobItemTemplate): void;
  onCancel(): void;
};
export default function ClaimTypeJobItemTemplatesEditForm(props: Props) {
  const { lang } = getLocales();

  return (
    <>
      <ModalForm<Model.IClaimTypeJobItemTemplate>
        subcomponents={ThemeModalFormDefault}
        dependencyArray={[props.data]}
        title={lang.jobItemTemplate}
        default={props.data || {}}
        onCancel={props.onCancel}
        onSubmit={props.onSave}
        validation={(data, errors) => {
          if (!data.jobItemTypeCode) set(errors, 'jobItemTypeCode', lang.required);
          if (!data.lossCodes || isEmpty(data.lossCodes)) set(errors, 'lossCodes._objectError', lang.required);
        }}
        render={({ form }) => (
          <FormWrapper>
            <SelectInput
              name="jobItemTypeCode"
              label={lang.typeCode}
              data={Object.values(LineItem)
                .filter((it) => it !== 'Deductible')
                .map((it) => ({ id: it, title: it }))}
              value={form.data?.jobItemTypeCode}
              onChange={form.update}
              error={form.errors?.jobItemTypeCode}
            />
            &nbsp;
            <SelectInput
              name="lossCodes"
              label={lang.lossCodes}
              data={props.lossCodes?.map((it) => it.displayInfo)}
              value={form.data?.lossCodes?.map((it) => it.id)}
              onChange={({ lossCodes: idList }) => {
                form.update({ lossCodes: idList?.map((id) => ({ id })) });
              }}
              isMultiselect
              error={form.errors?.lossCodes?._objectError}
            />
            &nbsp;
            <NumberInput
              label={lang.adjustedAmt}
              name="adjudication"
              value={form.data?.adjudication}
              onChange={form.update}
              style={{ input: { textAlign: 'right' } }}
              icon={<Icon>{'CAD'}</Icon>}
            />
          </FormWrapper>
        )}
      />
    </>
  );
}
